import { useSelector } from "react-redux";
import Card from "../../../../components/card/card";
import { PostBroadcastProvider } from "../../../../components/posts/post-broadcast.context";
import { useBroadcastScore } from "../../../../hooks/use-broadcast-score";
import { usePosts } from "../../../../hooks/use-posts";
import {
	selectBroadcastId,
	selectBroadcastUserId,
	selectFeedHeaderData,
	selectFixtureId,
} from "../../../../redux/broadcast/broadcast.selectors";
import * as SharedCSS from "../../broadcast-portal.styles";
import FeedHeader from "./feed-header/feed-header";
import { getPostItem } from "./feed-items/feed-items.factory";
import FeedVarReview from "./feed-var-review/feed-var-review";

const FeedModule = () => {
	const broadcastId = useSelector(selectBroadcastId);
	const broadcastUserId = useSelector(selectBroadcastUserId);
	const fixtureId = useSelector(selectFixtureId);
	const headerData = useSelector(selectFeedHeaderData);
	const posts = usePosts(broadcastId);
	const { homeScore, awayScore, varReview } = useBroadcastScore(broadcastId);

	return (
		<SharedCSS.SideColumn>
			<Card
				title="Feed"
				header={
					<>
						{varReview && <FeedVarReview />}
						<FeedHeader
							{...headerData}
							homeScore={homeScore}
							awayScore={awayScore}
						/>
					</>
				}
			>
				<PostBroadcastProvider
					value={{
						broadcastId,
						broadcastUserId,
						fixtureId,
						homeTeam: headerData.homeTeam,
						awayTeam: headerData.awayTeam,
						homeLogo: headerData.homeLogo,
						awayLogo: headerData.awayLogo,
					}}
				>
					<div>{posts.map((post) => getPostItem(post))}</div>
				</PostBroadcastProvider>
			</Card>
		</SharedCSS.SideColumn>
	);
};

export default FeedModule;
